import React, { useCallback } from "react";
import { Box, BoxProps, Button, withStyles } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
import { useNavigator } from "../AppHistory";

const ChipButton = withStyles((theme) => ({
  root: {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    borderRadius: 4,
    lineHeight: "26px",
  },
}))(Button) as typeof Button;

export const BackButton: React.FC<BoxProps> = ({ ...boxProps }) => {
  const { goBack } = useNavigator();
  const handleClick = useCallback(() => {
    goBack();
  }, [goBack]);

  return (
    <Box {...boxProps}>
      <ChipButton
        onClick={handleClick}
        color="primary"
        variant="text"
        startIcon={<ArrowBack />}
      >
        Back
      </ChipButton>
    </Box>
  );
};
